import {
  SET_DEPTS,
  SET_DEPTS_TREE,
  SET_EXPAND_DEPTS,
  REMOVE_FROM_EXPAND_DEPTS,
  SET_LATEST_ADDED_DEPT,
  SET_LATEST_EDITED_DEPT,
  SET_DEPTS_BIN,
  SET_DEPTS_UPDATED,
} from '../constants/DeptConstants';

const initialState = {
  depts: {
    list: [],
    tree: [],
    count: 0,
    // 当前部门树中已展开的部门id集合
    expandIDs: [],
    // 最后一个增加的部门id
    latestAddedDeptID: null,
    // 最后一个编辑的部门id
    latestEditedDeptID: null,
    // 部门回收站
    bin: [],
  },
  // 列表页是否需要刷新
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DEPTS: {
      const depts = {
        ...state.depts,
        list: action.payload.list,
        count: action.payload.count,
      };
      return {
        ...state,
        depts,
        updated: false,
      };
    }

    case SET_DEPTS_TREE: {
      const depts = {
        ...state.depts,
        // tree: convertDeptsTree(action.payload)  ,
        tree: action.payload,
      };
      return {
        ...state,
        depts,
      };
    }

    case SET_EXPAND_DEPTS: {
      const depts = {
        ...state.depts,
        expandIDs: action.payload,
      };
      return {
        ...state,
        depts,
      };
    }

    case REMOVE_FROM_EXPAND_DEPTS: {
      const newExpandIDs = state.depts.expandIDs;
      // TODO: 这里其实还有一点不严谨，因为只删除了当前删除的部门，没有删除其相关的父部门（如果父部门中没有其他展开项目的话）
      const removeIndex = state.depts.expandIDs.indexOf(action.payload);
      if (removeIndex > -1) newExpandIDs.splice(removeIndex, 1);
      const depts = {
        ...state.depts,
        expandIDs: newExpandIDs,
      };
      return {
        ...state,
        depts,
      };
    }

    case SET_LATEST_ADDED_DEPT: {
      const deptSequenceArray = action.payload.split('-').map(Number);
      const depts = {
        ...state.depts,
        // 新增清空下，用户可能手动选择父部门，为了可以看到操作的部门，将相关的部门id序列注入expandIDs;
        expandIDs: [...new Set(state.depts.expandIDs.concat(deptSequenceArray))],
        // 数组第一个元素即是当前操作部门的id;
        latestAddedDeptID: deptSequenceArray[0],
      };
      return {
        ...state,
        depts,
      };
    }

    case SET_LATEST_EDITED_DEPT: {
      const deptSequenceArray = action.payload.split('-').map(Number);
      const depts = {
        ...state.depts,
        // 编辑项目肯定是手动展开的，所以这里不需要将对应的父deptid值加入expandIDs里面;
        // 数组第一个元素即是当前操作部门的id;
        latestEditedDeptID: deptSequenceArray[0],
      };
      return {
        ...state,
        depts,
      };
    }

    case SET_DEPTS_BIN: {
      return {
        ...state,
        bin: action.payload,
      };
    }

    case SET_DEPTS_UPDATED: {
      return {
        ...state,
        updated: action.payload,
      };
    }

    default:
      return state;
  }
}
